const n = "Chargement en cours", o = {
  loading: n
};
export {
  o as default,
  n as loading
};
